import { store } from "../app/store";
import { localSelectors, getTranslation, directTranslation } from "../features/score/translationsSlice";

export const translate = (key, state) => directTranslation((state) ? state.translations : store.getState().translations, key);

export default translate;